/**
 * 店家公告顯示邏輯工具
 * 管理每個商店的公告顯示狀態，與登入狀態綁定
 * 使用 sessionStorage 實現：關閉瀏覽器前同一商店公告只顯示一次
 */

const STORAGE_KEY = 'store_notice_shown'

/**
 * 取得已顯示公告的商店列表（按使用者區分）
 * 使用 sessionStorage，每次開新分頁或重啟瀏覽器都會重置
 * @param {string} userIdentifier - 使用者識別碼（如 store_member_uuid）
 * @returns {Object} 已顯示公告的商店列表
 */
export const getShownNoticeStores = (userIdentifier) => {
    try {
        const stored = sessionStorage.getItem(`${STORAGE_KEY}_${userIdentifier}`)
        return stored ? JSON.parse(stored) : {}
    } catch (error) {
        console.error('讀取公告顯示記錄失敗:', error)
        return {}
    }
}

/**
 * 標記商店公告已顯示
 * 記錄在 sessionStorage 中，關閉瀏覽器後會重置
 * @param {string} userIdentifier - 使用者識別碼
 * @param {string} storeCode - 商店代號
 */
export const markNoticeAsShown = (userIdentifier, storeCode) => {
    try {
        const shownStores = getShownNoticeStores(userIdentifier)
        shownStores[storeCode] = true
        sessionStorage.setItem(`${STORAGE_KEY}_${userIdentifier}`, JSON.stringify(shownStores))
    } catch (error) {
        console.error('儲存公告顯示記錄失敗:', error)
    }
}

/**
 * 檢查是否應該顯示商店公告
 * @param {string} userIdentifier - 使用者識別碼
 * @param {string} storeCode - 商店代號
 * @param {boolean} noticeEnable - 公告是否啟用
 * @param {string} noticeContent - 公告內容
 * @returns {boolean} 是否應該顯示公告
 */
export const shouldShowNotice = (userIdentifier, storeCode, noticeEnable, noticeContent) => {
    if (!userIdentifier || !storeCode || !noticeEnable || !noticeContent) return false

    const shownStores = getShownNoticeStores(userIdentifier)
    return !shownStores[storeCode]
}

export default {
    getShownNoticeStores,
    markNoticeAsShown,
    shouldShowNotice
}